import { render, staticRenderFns } from "./ConsentBanner.vue?vue&type=template&id=21068054&scoped=true"
import script from "./ConsentBanner.vue?vue&type=script&lang=js"
export * from "./ConsentBanner.vue?vue&type=script&lang=js"
import style0 from "./ConsentBanner.vue?vue&type=style&index=0&id=21068054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21068054",
  null
  
)

export default component.exports